import { render } from "./KeyboardSpace.vue?vue&type=template&id=7e567c13"
import script from "./KeyboardSpace.vue?vue&type=script&lang=js"
export * from "./KeyboardSpace.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/KeyboardSpace.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e567c13"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e567c13', __exports__)) {
    api.reload('7e567c13', __exports__)
  }
  
  module.hot.accept("./KeyboardSpace.vue?vue&type=template&id=7e567c13", () => {
    api.rerender('7e567c13', render)
  })

}


export default __exports__